import { detectInviteType, type InviteType } from "@ano/shared/api/invites";

/**
 * Pure derivation of the unauthenticated guest/invite branch selection used by
 * `AuthGate`. Extracted so the eligibility rule is unit-tested and the AuthGate
 * render ladder stays a flat set of conditional returns.
 *
 * `guestInviteToken` is the `?invite=` / `?space_invite=` query param (null when
 * absent). A DM or group-DM invite is "guest-eligible" — the visitor can read
 * the thread without an account via GuestMode; any other invite type routes to
 * the InviteLoginPage instead.
 */
export function readGuestInviteTokenFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get("invite") ?? params.get("space_invite") ?? null;
}

export function deriveGuestEligibility(guestInviteToken: string | null): {
  guestInviteType: InviteType | null;
  isGuestEligible: boolean;
} {
  const guestInviteType = guestInviteToken
    ? detectInviteType(guestInviteToken)
    : null;
  const isGuestEligible =
    guestInviteType === "dm" || guestInviteType === "group_dm";
  return { guestInviteType, isGuestEligible };
}
